// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 351 ? "commons" : chunkId) + "." + {"225":"b0d256a4","351":"76e4406e","559":"9e98bde8","799":"7fdb8610"}[chunkId] + ".chunk.css";
};